import { CrewMember, FitupRequest, Weld } from '@bechtel/types';
import { t } from '@lingui/macro';

export interface WeldAssignReassignProps {
  weldIds: Weld['id'][];
  isFitupRequired: boolean;
  close: () => void;
  fitupRequest?: FitupRequest;
  isReassign?: boolean;
  isFlangeSidesheet?: boolean;
  weld?: Weld;
  showItrCertDialog?: boolean;
}

export const fitUpRequireWeldingScopes = [
  { value: true, label: t`Yes` },
  { value: false, label: t`No` },
];

export interface WeldAssignFormikState {
  weld?: Weld;
  isFitupRequired?: boolean;
  installationCrewMember: CrewMember | null;
  fitupRequiredWelding?: boolean;
  comments?: string;
}
